import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import { SubdomainProvider } from "./providers/SubdomainProvider";
import { Auth0ProviderWithNavigate } from "./providers/auth0-provider-with-navigate";
import { ModalStackProvider } from "./contexts/ModalStackContext";
import { ThemeModeProvider } from "./providers/ThemeModeProvider";
import { initializeOpenTelemetry } from "./telemetry";
import "./styles/styles.css";
import "./components/onyx/chrome";

// Initialize OpenTelemetry before anything else
initializeOpenTelemetry();

const container = document.getElementById("root");
const root = createRoot(container);
console.log("🚀 React index.js loaded!");
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SubdomainProvider>
        <Auth0ProviderWithNavigate>
          <ThemeModeProvider>
            <ModalStackProvider>
              <App />
            </ModalStackProvider>
          </ThemeModeProvider>
        </Auth0ProviderWithNavigate>
      </SubdomainProvider>
    </BrowserRouter>
  </React.StrictMode>
);
